<template>
  <v-list-item :class="active ? 'active' : 'inactive'" ripple v-on="$listeners">
    <v-list-item-action style="min-width: 42px;">
      <slot name="icon"></slot>
      <v-icon v-if="!$slots.icon">
        {{ icon }}
      </v-icon>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title :class="{ selected: active }">
        <slot></slot>
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'AbfFilterItem',
  props: ['active', 'icon']
};
</script>

<style lang="scss" scoped>
.inactive {
  --fa-primary-color: gray;
  --fa-secondary-color: dimgray;
}
.active {
  --fa-primary-color: #321a32;
  --fa-secondary-color: #5c415b;
}
</style>
